/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ManagedObjectDTO } from './managed-object-dto';
import { RealmDTO } from './realm-dto';
import { UserStatusDTO } from './user-status-dto';


/**
 * Defines a user
 */
export interface UserAllOfDTO { 
    /**
     * User id
     */
    id?: string;
    /**
     * Username
     */
    username?: string;
    /**
     * User Email
     */
    email?: string;
    status?: UserStatusDTO;
    /**
     * User emailVerified
     */
    emailVerified?: boolean;
    /**
     * Tenant identifier (UUID)
     */
    tenantId?: string;
    managedObject?: ManagedObjectDTO;
    realm?: RealmDTO;
    /**
     * Creation date
     */
    createdDate?: string;
}

export class ClsUserAllOfDTO { 
    /**
     * User id
     */
    id?: string = undefined;
    /**
     * Username
     */
    username?: string = undefined;
    /**
     * User Email
     */
    email?: string = undefined;
    status?: UserStatusDTO = undefined;
    /**
     * User emailVerified
     */
    emailVerified?: boolean = undefined;
    /**
     * Tenant identifier (UUID)
     */
    tenantId?: string = undefined;
    managedObject?: ManagedObjectDTO = undefined;
    realm?: RealmDTO = undefined;
    /**
     * Creation date
     */
    createdDate?: string = undefined;
}



